import { sdkMessageFormatter } from '@glovo/o11y-core';
const formatter = sdkMessageFormatter('RUM');
export const consoleIntegration = (consoleInstance) => {
    return {
        init() {
            consoleInstance.log(...formatter('info', 'init'));
        },
        addError(error, context) {
            consoleInstance.group(...formatter('error', 'addError'));
            consoleInstance.error(error);
            consoleInstance.log(context);
            consoleInstance.groupEnd();
        },
        clearUser() {
            consoleInstance.log(...formatter('info', 'clearUser'));
        },
        setContext(key, value) {
            consoleInstance.groupCollapsed(...formatter('info', 'setContext'));
            consoleInstance.log(key);
            consoleInstance.log(value);
            consoleInstance.groupEnd();
        },
        setUser(user) {
            consoleInstance.groupCollapsed(...formatter('info', 'setUser'));
            consoleInstance.log(user);
            consoleInstance.groupEnd();
        },
        addAction(actionName, context) {
            consoleInstance.groupCollapsed(...formatter('info', `addAction: ${actionName}`));
            consoleInstance.dir(context);
            consoleInstance.groupEnd();
        },
        setRouteName(name) {
            consoleInstance.groupCollapsed(...formatter('info', 'setRouteName'));
            consoleInstance.log(name);
            consoleInstance.groupEnd();
        },
        addTiming(name, time) {
            consoleInstance.groupCollapsed(...formatter('info', 'addTiming'));
            consoleInstance.log(name);
            consoleInstance.log(time);
            consoleInstance.groupEnd();
        },
    };
};
//# sourceMappingURL=index.js.map